import { Chip, Tooltip } from "@mui/material";

const TruncatedChip: React.FC<{
    label: string;
    maxLength?: number;
    sx?: any;
}> = ({ label, maxLength = 20, sx }) => {
    const shouldTruncate = label && label.length > maxLength;
    const displayLabel = shouldTruncate ? `${label.substring(0, maxLength)}...` : label;
    
    const chipElement = (
        <Chip
            label={displayLabel}
            size="small"
            sx={{
                ...sx,
                fontWeight: 'medium',
                maxWidth: '100%',
                '& .MuiChip-label': {
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                }
            }}
        />
    );

    return shouldTruncate ? (
        <Tooltip
            title={label} 
            arrow 
            placement="top"
            componentsProps={{
                tooltip: {
                    sx: {
                        fontSize: '0.95rem',
                        padding: '10px 10px',
                        maxWidth: 'none'
                    },
                },
            }}
        >
            {chipElement}
        </Tooltip>
    ) : (
        chipElement
    );
};

export default TruncatedChip;